import { Pipe, PipeTransform } from '@angular/core';
import momenttz from 'moment-timezone';

@Pipe({
    name: 'sort',
})
export class SortPipe implements PipeTransform {

    transform(items: [], column: string, type: string = null, orderDesc: boolean = false) {
        return [...items.sort(function (a: any, b: any) {
            if ('datestring' === type) {
                const aDate = momenttz.tz(a[column], 'Europe/Tallinn').toDate();
                const bDate = momenttz.tz(b[column], 'Europe/Tallinn').toDate();
                return compareElements(aDate, bDate, orderDesc);
            } else if (typeof (a[column]) === 'number') {
                return compareElements(a[column], b[column], orderDesc);
            } else if (typeof (a[column]) === 'string') {
                let aString = a[column].trim().replace(/\s/g, '').toLowerCase();
                let bString = b[column].trim().replace(/\s/g, '').toLowerCase();
                return orderDesc ? bString.localeCompare(aString) : aString.localeCompare(bString);
            } else {
                console.log(`SORTING NOT IMPLEMENTED FOR TYPE: ${typeof (a[column])}`);
            }
        })];
    }
}

function compareElements(a: any, b: any, orderDesc: boolean): number {
    if (a > b) {
        return orderDesc ? -1 : 1;
    } else if (a < b) {
        return orderDesc ? 1 : -1;
    } else {
        return 0;
    }
}

